//src/pages/REG/REG210F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import style from "./REG210F1.module.scss";
import Modal from "components/Modal/Modal";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import { dateToYMD, ymdToDate } from './REGComUtil'; //
import dayjs from 'dayjs';
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import Icon from "../../components/Icon/Icon";
import DataGrid from "../../components/DataGrid/DataGrid";

import {MenuContext} from "pages/COM/COM001L1";
import TextArea from "../../components/TextArea/TextArea";
import RadioGroup from "../../components/Radio/RadioGroup";



// 페이지 시작
const REG210F1 = ({navBar: NavBar, isActive}) => {

    const { addPage_manual } = useContext(MenuContext);
    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]);
    //검색 조건
    const [schUserNm, setSchUserNm] = useState('');
    const [isReadHospital, setIsReadHospital] = useState(true);

    //사용자리스트
    const [rows_NoticeList, setRows_NoticeList] = useState([]);
    const searchObj = [
        { name:"hsptCd", value: 'H0AA'},
        { name:"subjectNo", value: ''},
        { name:"fromDt", value: ''},
        { name:"toDt", value: ''},
        { name:"initial", value: ''}

    ];

    const [rows_QueryList, setRows_QueryList] = useState([]);
    const cols_QueryList = [
        { key: 'hsptNm', name: '기관명',  width: '30%' },
        { key: 'subjectCd',     name: 'Subject No.',  width: '20%' },
        { key: 'initial',     name: 'initial',  width: '10%' },
        { key: 'acquisitionDt', name: '동의서취득일',  width: '20%' },
        // { key: 'age',        name: '나이',    width: '8%'},
        // { key: 'sexNm',      name: '성별',  width: '8%'},
        { key: 'reviewRegCnt',      name: '등록건수',  width: '10%'},
        { key: 'reviewCompleteCnt',      name: '완료건수',  width: '10%'},
    ];



    const [rows_mstList, setRows_mstList] = useState([]);
    const cols_mstList = [
        { key: 'subjectCd',       name: 'Subject No.',  width: '20%' },
        { key: 'reviewId',        name: 'Seq',  width: '15%' },
        { key: 'reviewTitle',     name: '제목',  width: '40%' },
        { key: 'currentStatusNm', name: '현재상태',  width: '20%' },
        { key: 'reviewRegYmd',    name: '등록일', width: '25%' }

    ];
    const [rows_dtlList, setRows_dtlList] = useState([]);
    const cols_dtlList = [
        { key: 'reviewIdSeq',   name: 'No.',    width: '20%' },
        { key: 'reviewUserNm',  name: '등록자',  width: '30%' },
        { key: 'reviewStatusNm',name: '상태이력',    width: '20%' },
        { key: 'reviewTime',    name: '작성일시', width: '30%' }
    ];

    /* 컴포넌트 세팅 정보 */
    const [reviewTitle, setReviewTitle] = useState('');
    const [dtlNote, setDtlNote] = useState('');
    const radioOptions = [
        {mapCd: 'reviewStatus', value: "A", label: "확인요청"}
        ,{mapCd: 'reviewStatus', value: "B", label: "작업완료"}
        ,{mapCd: 'reviewStatus', value: "C", label: "최종완료"}
    ];
    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }
    const [reviewStatus, setReviewStatus] = useState('');
    const [currentStatus, setCurrentStatus] = useState('');
    const [reviewNote, setReviewNote] = useState('');
    //상세내용 신규등록 관련
    const [dsAddObj, setDsAddObj] = useState({
        mstId:"", reviewId:"", currentStatus:"" ,reviewNote:""
    });
    const setDsAddValue = (name, value) => {
        setDsAddObj(prev => ({
            ...prev,
            [name]: value
        }));
    }
    const initAddObj = ()=>{
        setDsAddObj({
            mstId:"", reviewId:"", currentStatus:"",reviewNote:""
        })
    }


    /* *********************************************************  컴포넌트 세팅 */
    const [isComCodeReady, setIsComCodeReady] = useState(false);
    //form load
    useEffect(() => {
        //공통코드 조회
        // const fetchComCode = async () => {
        //     await getComDtlsData();
        //     await getQueryList();
        // };
        // fetchComCode();
        const fetchAll = async () => {
            //console.log('공통코드 조회 시작');
            await getComDtlsData(); // 공통코드 조회 및 세팅
            setIsComCodeReady(true);
            if(userInfo.roleId==="300001"){
                //특정 권한의 경우 조회가능
                setIsReadHospital(false);
            }
        };
        fetchAll();
    }, []);

    useEffect(() => {
        if (isComCodeReady && isActive) {
            getQueryList();
        }
    }, [isComCodeReady, isActive]);

    const [inputData, setInputData]  = useState(searchObj);

    //데이터 get, set
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };

    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }

    const getItemLabel = (getName) =>{
        return inputData.find(item => item.name === getName).label;
    }

/* EVENT *************************************************************************************** */

    //조회 버튼 클릭
    const handleClick_search = (e) => {
        getQueryList();
    }

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };

    // Query 그리드 클릭
    const onClick_gridQuery_row = (e) => {
        getReviewMst(e.row.mstId, e.row.hsptCd);
    }
    // Query 그리드 더블클릭
    const doubleClick_gridQuery_row = (e) => {

        const reStatYn = 'Y';
        const param = {mstId:e.row.mstId, hsptCd: e.row.hsptCd};

        const selMenu = {
            menuCd:"REG300F1",
            menuId:"030003",
            menuPos:"연구 > edit",
            menuTl:"edit"
        }
        addPage_manual(selMenu, param, reStatYn); //화면 열기 - 변경 필요 현 하드 코딩되어 있음.
    }

    //MST 데이터 클릭
    const onClick_mstGrid_row = (e) => {
        //console.log(e.row.mstId + ' / ' + e.row.reviewId)
        getReviewDtl(e.row.mstId, e.row.hsptCd, e.row.reviewId);

        //initAddObj();
        //setDsAddValue("mstId",e.row.mstId);
        //setDsAddValue("reviewId",e.row.reviewId);
        //setDsAddValue("currentStatus",e.row.currentStatus);
    }
    const onClick_DtlGrid_row = (e) => {
        //console.log(e.row.mstId + ' / ' + e.row.reviewId)

        setDtlNote(e.row.reviewNote);
        setReviewTitle(e.row.reviewTitle);

    }

    //연구기관 변경시 검색조건 초기화 및 조회
    const onChange_hospital = (value) => {
        setItemValue("hsptCd", value);
        setItemValue("fromDt", "");
        setItemValue("toDt", "");
        setItemValue("subjectNo", "");
        setItemValue("initial", "");
        setRows_QueryList([]);
        setRows_mstList([]);
        setRows_dtlList([]);

    }


/* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setItemValue("hsptCd", userInfo.hsptCd);

    }

    /* 쿼리 리스트 조회
    *
    * */
    async function getQueryList(){
        //메인 데이터 조회
        setRows_QueryList([])
        setRows_mstList([]);
        setRows_dtlList([]);
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        const res = await postData("/REW/getReviewStatusList", getParam);
        setRows_QueryList(res);

    }

    async function getReviewMst(workMstId, workHsptCd){
        //initAddObj();
        setRows_mstList([]);
        setRows_dtlList([]);

        setDtlNote("");
        setReviewTitle("");

        const param = { mstId:workMstId, hsptCd:workHsptCd};
        const res = await postData("/REW/getReviewMst", param);
        setRows_mstList(res);

    }
    async function getReviewDtl(workMstId, workHsptCd, workReviewId){
         setRows_dtlList([]);
         //initAddObj();

         //상세 데이터 조회
         const paramDtl = { mstId:workMstId, hsptCd:workHsptCd, reviewId:workReviewId};
         const res = await postData("/REW/getReviewDtl", paramDtl);
         setRows_dtlList(res);
         setReviewTitle('');
         setDtlNote('');
    }



    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={()=> handleClick_search()}>
                        조회
                    </Button>
                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr>
                        <td className={style.content_typ1} style={{width:"5%"}}>
                            연구기관
                        </td>
                        <td>
                            <SelectBox options={comHsptObj} valueKey="comnDtlsCd" labelKey="detlCdNm"
                                       value={getItemValue("hsptCd")}
                                       //onChange={(value) => setItemValue("hsptCd", value)}
                                       onChange={(value) => onChange_hospital(value)}
                                       isDisabled={isReadHospital}
                                       isAllExpr={false}/>
                        </td>
                        <td className={style.content_typ1} style={{width:"7%"}}> 동의서 취득일</td>
                        <td style={{width:"7%"}}>
                            <div className={style.content_typ2}>
                                <DatePicker selDate={ymdToDate(getItemValue('fromDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('fromDt', dateToYMD(date))}/>
                                {insertSpace(2)}~{insertSpace(2)}
                                <DatePicker selDate={ymdToDate(getItemValue('toDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('toDt', dateToYMD(date))}/>
                            </div>
                        </td>
                        <td className={style.content_typ1} style={{width:"6%"}}> Subject No.</td>
                        <td style={{width: "5%"}}>
                            <InputUnitText type={"text"} value={getItemValue('subjectNo')} unit={""}
                                           onChange={(value) => setItemValue('subjectNo', value.toUpperCase())}/>
                        </td>
                        <td className={style.content_typ1} style={{width:"4%"}}> Initial</td>
                        <td>
                            <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}
                                           onChange={(value) => setItemValue('initial',  value.toUpperCase())}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>
            <div style={{width:"100%"}}>
                <table style={{ height: "100%"}}>
                    <tbody>
                    <tr>
                        <td style={{width: "550px", verticalAlign:"top", height:"100%"}}>
                            <DataGrid
                                cols={cols_QueryList}
                                rows={rows_QueryList}
                                rowHeight={37}
                                onCellClick={(e) => onClick_gridQuery_row(e)}
                                onCellDoubleClick={(e) => doubleClick_gridQuery_row(e)}
                                sortable={true}
                                isNodataView={true}
                            />
                        </td>
                        <td style={{width: "480px",  verticalAlign: "top",paddingLeft:"10px", paddingRight:"10px"
                        }}>
                            <div style={{height:"800px"}}>
                                <DataGrid
                                    cols={cols_mstList}
                                    rows={rows_mstList}
                                    rowHeight={37}
                                    onCellClick={(e) => onClick_mstGrid_row(e)}
                                    sortable={true}
                                    isNodataView={true}
                                />
                            </div>

                        </td>
                        <td style={{width: "430px", height:"300px",  verticalAlign: "top"}}>
                            <div style={{height: "40%"}}>
                                <DataGrid
                                    cols={cols_dtlList}
                                    rows={rows_dtlList}
                                    rowHeight={37}
                                    // onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                                    onCellClick={(e) => onClick_DtlGrid_row(e)}
                                    sortable={true}
                                    isNodataView={true}
                                />
                                <div className={styleCom.title_wrap} style={{marginBottom: "10px"}}>
                                    <h3>Title</h3>
                                </div>
                                <TextArea width={'100%'} height={"50px"} readOnly={true}
                                          value={reviewTitle}/>
                                <div className={styleCom.title_wrap} style={{marginBottom: "10px"}}>
                                    <h3>View Query Details</h3>
                                </div>
                                    <TextArea width={'100%'} height={"auto"} readOnly={true}
                                              value={dtlNote}/>

                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>


            </div>

        </main>


    )
        ;
};


export default REG210F1;
